import { render, staticRenderFns } from "./IconSvgShare.vue?vue&type=template&id=39291610&scoped=true&"
import script from "./IconSvgShare.vue?vue&type=script&lang=js&"
export * from "./IconSvgShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39291610",
  null
  
)

export default component.exports